import React from 'react';
import { ReactComponent as MoreIcon } from 'common/icons/dots-horizontal.svg';

export type MoreButtonProps = {
  className?: string;
  onClick?: () => void;
};

const MoreButton = ({ className, onClick }: MoreButtonProps) => {
  return (
    <button onClick={onClick} className={`planner-plus-button ${className || ''}`}>
      <MoreIcon className='svg-black' />
    </button>
  );
};

export default MoreButton;
